import styled from 'styled-components';

export interface IButtonProps {
    onClick?: (filterEventsItemId: number) => void;
}

export const OuterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 100%;
    padding: 0;

    .rotation-port-name {
        cursor: pointer;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        border: 0;
        text-align: left;
        color: ${props => props.theme.colors.text.portName};
        font-weight: 500;
        font-size: 0.9rem;
        padding: 0.5rem 4rem 0.5rem 0.5rem;
    }
    .rotation-berth-name {
        cursor: pointer;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        border: 0;
        text-align: left;
        color: ${props => props.theme.colors.text.portName};
        background: ${props => props.theme.colors.background.hover.default};
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0.5rem 4rem 0.5rem 0.5rem;
    }
    .rotation-cargo-name {
        cursor: pointer;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        border: 0;
        text-align: left;
        color: ${props => props.theme.colors.text.portName};
        background: ${props => props.theme.colors.background.hover.default};
        font-size: 0.75rem;
        font-weight: 400;
        padding: 0.5rem 4rem 0.5rem 0.5rem;
    }
`;

export const EventListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .event-date {
        font-size: 0.8rem;
        margin-right: 10px;
        flex: 0 0 110px;
    }
    .event-display-name {
        font-weight: 500;
        font-size: 0.8rem;
        flex: 0 0 calc(100% - 150px);
        overflow: hidden;
        .ext-info {
            display: block;
            h5 {
                display: inline-block;
                margin-right: 3px;
            }
            .cargo-name {
                font-weight: 400;
                font-size: 0.7rem;
                margin-right: 3px;
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                &::before {
                    content: '•';
                    padding: 0 5px 0 0;
                }
            }
            .dropdown-item-name {
                font-weight: 400;
                font-size: 0.7rem;
                margin-right: 3px;
                display: block;
                white-space: wrap;
                overflow: hidden;
                text-overflow: ellipsis;
                &::before {
                    // content: "•";
                    padding: 0 5px 0 0;
                }
            }
        }
    }
`;

export const PortCallEventItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 20px;
`;

export const BerthCallEventWrapper = styled.div``;

export const NoEventsWrapper = styled.div`
    padding-left: 20px;
`;
